export const overrides = {
  MuiPopover: {
    root: {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- FIXME: Fix this ESLint violation!
      zIndex: '1400 !important' as any,
    },
  },
}
